/**
 * Function to Set data in localStorage
 * @param keyName{string} - key for store data in localStorage
 * @param defaultValue - data response
 */

import { useMemo } from 'react';

const writeToCache = (keyName, defaultValue) => {
    try {
        const value = window.localStorage.getItem(keyName);
        if (value) {
            return JSON.parse(value);
        } else {
            window.localStorage.setItem(keyName, JSON.stringify(defaultValue));
            return defaultValue;
        }
    } catch (err) {
        return defaultValue;
    }
};

/**
 * Function to Get Data
 * @param key{string} - key for read data in localStorage
 * @return {any | null}
 */

const readFromCache = (key) => JSON.parse(window.localStorage.getItem(key)) || null;

/**
 * Function to TOKEN
 * @param key{string} - key for read data in localStorage
 * @return {any | null}
 */

const readTokenFromCache = (key) => window.localStorage.getItem(key) || null;

function useLocalJson(key) {
    const value = useMemo(() => {
        try {
            const raw = localStorage.getItem(key);
            return raw ? JSON.parse(raw) : {};
        } catch (e) {
            console.error('Failed to parse', key, e);
            return {};
        }
    }, [key]); // hanya parse ulang bila key berubah

    return value;
}

export { readFromCache, readTokenFromCache, useLocalJson, writeToCache };

